import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';
import { denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { EMAIL_SENDS, INTEGRATION_EVENTS, EMAIL_UNBOUNCES } from '../../timeline/constants/TimelineConstants';
export const fillExtraEventOptions = (objectType, eventTypes) => {
  let eventTypesToSave = eventTypes.toSet();
  const hasIntegrations = eventTypesToSave.find(eventOption => {
    return /integrations-app.*/.test(eventOption);
  });
  const hasEmailSends = eventTypesToSave.has(EMAIL_SENDS);
  if (hasIntegrations) {
    eventTypesToSave = eventTypesToSave.add(INTEGRATION_EVENTS);
  }
  if (!hasIntegrations && eventTypesToSave.has(INTEGRATION_EVENTS)) {
    eventTypesToSave = eventTypesToSave.remove(INTEGRATION_EVENTS);
  }
  if (objectType === CONTACT && hasEmailSends) {
    eventTypesToSave = eventTypesToSave.add(EMAIL_UNBOUNCES);
  }
  if (objectType === CONTACT && !hasEmailSends) {
    eventTypesToSave = eventTypesToSave.remove(EMAIL_UNBOUNCES);
  }
  return eventTypesToSave.toList();
};
export const fillExtraEventOptionsJS = ({
  objectTypeOrId,
  eventTypes
}) => {
  const objectType = denormalizeTypeId(objectTypeOrId);
  const eventTypesToSave = new Set(eventTypes);
  const hasIntegrations = eventTypes.some(eventOption => /integrations-app.*/.test(eventOption));
  const hasEmailSends = eventTypesToSave.has(EMAIL_SENDS);
  if (hasIntegrations) {
    eventTypesToSave.add(INTEGRATION_EVENTS);
  }
  if (!hasIntegrations && eventTypesToSave.has(INTEGRATION_EVENTS)) {
    eventTypesToSave.delete(INTEGRATION_EVENTS);
  }
  if (objectType === CONTACT && hasEmailSends) {
    eventTypesToSave.add(EMAIL_UNBOUNCES);
  }
  if (objectType === CONTACT && !hasEmailSends) {
    eventTypesToSave.delete(EMAIL_UNBOUNCES);
  }
  return [...eventTypesToSave];
};